export const SET_CANVAS = "canvas/SET_CANVAS";
export const FETCH_CANVAS = "canvas/FETCH_CANVAS";
export const SET_CANVAS_IMAGES = "canvas/SET_CANVAS_IMAGES";
export const TOGGLE_LIGHTS = "canvas/TOGGLE_LIGHTS";
export const SET_FRAME = "canvas/SET_FRAME";
export const SET_HOVERED_LOT = "canvas/SET_HOVERED_LOT";
